module.exports = __webpack_public_path__ + "static/74invgde-4b7a26d9ffb6e2d6a10a5b429136bd95.gif";